<span
  class="loading-dots"
  [class.loading-dots--small]="size() === 'small'"
  [class.loading-dots--medium]="size() === 'medium'"
  role="status"
  [attr.aria-label]="ariaLabel()"
>
  <span class="loading-dots__dot"></span>
  <span class="loading-dots__dot"></span>
  <span class="loading-dots__dot"></span>
</span>
